import classNames from "classnames/bind";
import styles from "./ChipList.module.css";

const cx = classNames.bind(styles);

export const ChipList = ({
  children,
  ariaLabel,
}: {
  children: React.ReactNode;
  ariaLabel?: string;
}) => {
  return (
    <div className={cx("container")} role="group" aria-label={ariaLabel}>
      {children}
    </div>
  );
};
